import ContentUpload from 'module/ContentUpload/ContentUpload';

import React, { useEffect, useRef } from 'react';

import { Button, Card, Form, Input, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { idCardRequired } from 'utils';
import {
  useGetArticleContentQuery,
  useGetCurrentUserQuery,
  useGetOfferQuery,
  useSendSupervisorOpinionMutation,
} from 'services';
import { useNavigate, useParams } from 'react-router-dom';
import { useApiErrorMessage } from 'hooks';

import AddMediaContent from './AddMediaContent';
import MediaActionProvider from './AddMediaContent/Context/MediaActioncontext';

const SupervisorSendItemsView = ({ backUrl = '/maddelerim' }) => {
  const { id } = useParams();
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { data: current_user } = useGetCurrentUserQuery();
  const { data: offer } = useGetOfferQuery(id);
  const articleType = offer && offer.articleType;
  const [sendSupervisorOpinion, { isLoading: isSending }] = useSendSupervisorOpinionMutation();
  const isSendingRef = useRef(false);
  const getErrorMessage = useApiErrorMessage();
  const { data } = useGetArticleContentQuery(
    {
      offerID: id,
    },
    {
      skip: !current_user,
    }
  );

  const itemFile = Form.useWatch('itemFile', form);
  const idCard = Form.useWatch('idCard', form);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        itemFile: data.contents.find((item) => item.type === 0),
        idCard: data.contents.find((item) => item.type === 1),
      });
    }
  }, [data, form]);

  /**
   * Bazi Madde tulerinde kimlik karti zorunlulugu bulunmakta bu turler
   * @see idCardRequired arrayinde JSDOC olarak belirtilmiştir
   * @type {boolean} bu constant turlerden birine ait olup olmamasina gore boolean deger doner
   */
  const isIdCardRequired = idCardRequired.includes(articleType && articleType.id);

  useEffect(() => {
    if (document) {
      // buradaki id degeri /src/routes/index.js dosyasindaki div in id degerini ifade ediyor
      const element = document.getElementById('routes-wrapper');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, []);

  // madde gönderme işlemi medya kaydetten tamamen farklı bir işlem
  const handleSendArticle = async (values) => {
    // Düğme `isSending` ile ancak bir sonraki render'da kilitlenir; araya giren hızlı tıklamaları ref keser.
    if (isSendingRef.current) return;
    isSendingRef.current = true;

    const { error } = await sendSupervisorOpinion({
      id,
      body: {
        opinion: 'approved',
        opinionDescription: values.opinionDescription,
      },
    });

    if (!error) {
      navigate(backUrl);
    } else {
      isSendingRef.current = false;
      message.error(getErrorMessage(error));
    }
  };

  /**
   * Yuklenene madde dosyalarinda zorunlu olanlarin hepsi yuklenmeden gonder butonunun aktif olmamasini saglar
   */
  const disableSendButton = Boolean(!itemFile) || (isIdCardRequired && Boolean(!idCard));

  return (
    <>
      <div className="gx-d-flex gx-justify-content-end">
        <Button
          onClick={() => navigate(-1)}
          type="default"
          style={{
            fontSize: 18,
          }}
        >
          <ArrowLeftOutlined />
          {formatMessage({
            id: 'goBack',
          })}
        </Button>
      </div>
      <Form
        id="add-new-article-form"
        layout="vertical"
        onFinish={handleSendArticle}
        form={form}
      >
        <ContentUpload
          id={id}
          articleTypeID={articleType && articleType.id}
        />
        <Card>
          <MediaActionProvider>
            <AddMediaContent offerID={id} />
          </MediaActionProvider>
        </Card>
        <Form.Item
          className="gx-mb-4"
          label="Açıklamalar ve Notlar"
          name="opinionDescription"
          normalize={(value) => (value.trim() === '' ? undefined : value)}
        >
          <Input.TextArea
            placeholder="Madde açıklaması giriniz"
            rows={5}
            showCount
          />
        </Form.Item>
        <Form.Item>
          <Button
            block
            disabled={disableSendButton}
            htmlType="submit"
            loading={isSending}
            type="primary"
          >
            {formatMessage({
              id: 'article.status.sendItem',
            })}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SupervisorSendItemsView;
